module.exports = __webpack_public_path__ + "img/useful01.879c5979.jpg";